import BigNumber from 'bignumber.js'

import { Box, Pool } from '@pancakeswap/uikit'
import { BIG_ZERO } from '@pancakeswap/utils/bigNumber'
import { Token } from '@pancakeswap/sdk'

import useActiveWeb3React from 'hooks/useActiveWeb3React'
import VaultApprovalAction from './VaultApprovalAction'
import VaultStakeActions from './VaultStakeActions'
import { useCheckVaultApprovalStatus } from '../../../hooks/useApprove'

const CakeVaultCardActions: React.FC<
  React.PropsWithChildren<{
    pool: Pool.DeserializedPool<Token>
    accountHasSharesStaked: boolean
    isLoading: boolean
    performanceFee: number
  }>
> = ({ pool, accountHasSharesStaked, isLoading, performanceFee }) => {
  const { userData } = pool
  const { chainId } = useActiveWeb3React()
  
  const stakingTokenBalance = userData?.stakingTokenBalance ? new BigNumber(userData.stakingTokenBalance) : BIG_ZERO

  const { isVaultApproved, setLastUpdated } = useCheckVaultApprovalStatus(pool.vaultKey, chainId)

  return !isVaultApproved && !accountHasSharesStaked ? (
    <Box mt="10px">
      <VaultApprovalAction vaultKey={pool.vaultKey} isLoading={isLoading} setLastUpdated={setLastUpdated} />
    </Box>
  ) : (
    <VaultStakeActions
      pool={pool}
      stakingTokenBalance={stakingTokenBalance}
      accountHasSharesStaked={accountHasSharesStaked}
      performanceFee={performanceFee}
    />
  )
}

export default CakeVaultCardActions
